
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {TranslateConfigService} from "./translate.config.service";
import * as _ from "lodash";

/**
* ***************************************************************
* Service for translate strings.
*
* Written by: Dana Moshe
* ***************************************************************
*/
@Injectable()
export class TranslateService{
	private translateOn:boolean;


	constructor(private translateConfigService:TranslateConfigService) {
		this.translateOn=true;
	}


	public toggleTranslate(){
		this.translateOn=!this.translateOn;
	}

	/**
	 * Gets the translated value of a key (or an array of keys).
	 *
	 * @param key key or keys to translate.
	 * @param interpolateParams parameters.
	 */
	public get(key:string | Array<string>, interpolateParams?:Object):Observable<string | Object> {
		if (!this.translateOn){
			return observableOf("["+this.getTranslatePlaceHolder(key,interpolateParams)+"]");
		}

		if (!key || (_.isArray(key) && !key.length) ){
			return observableOf(key);
		}else{
			return this.translateConfigService.get(key, interpolateParams);
		}
	}

	/**
	 * Gets the instant translated value of a key (or an array of keys).
	 * You can call this function just if the translation is loaded.
	 * (The translation load twice, one time before the login and the second time is after the login.
	 * So when you use this function inside the application, the translation already loaded.)
	 *
	 * @param key key or keys to translate.
	 * @param interpolateParams parameters.
	 */
	public instant(key:string|Array<string>, interpolateParams?:Object):string|Object {
		if (!this.translateOn){
			return "["+this.getTranslatePlaceHolder(key,interpolateParams)+"]";
		}
		if (!key || (_.isArray(key) && !key.length) ){
			return key;
		}else{
			return this.translateConfigService.instant(key, interpolateParams);
		}
	}

	/**
	 * Gets the instant translated value of Kendo filter operator (like eq, start with...).
	 *
	 * @param operator
	 * @returns the operator translate.
	 */
	public operator(operator: string): string{
		let kendoOperatorTranslationKey = this.getKendoOperatorTranslationKey(operator);
		return this.instant(kendoOperatorTranslationKey).toString();

	}

	private getTranslatePlaceHolder(key:string|Array<string>, interpolateParams?:Object){
		return key+(interpolateParams? JSON.stringify(interpolateParams):"");
	}

	/**
	 * Converts the operator to the full Kendo translation key
	 * @param operator
	 */
	private getKendoOperatorTranslationKey(operator: string): string {
		let key = 'kendo.grid.filter';
		switch (operator) {
			case 'startswith':
				key += 'StartsWith';
				break;
			case 'endswith':
				key += 'EndsWith';
				break;
			default:
				key += _.capitalize(operator);
				break;
		}
		key += 'Operator';
		return key;
	}
}
